<script>
  // ?id=9921&dnApp=1&dnAppVersion=6.5.5
  import { onMount } from "svelte";
  import InlineSVG from "svelte-inline-svg";
  import {
    baseUrl,
    getUrlVars,
    inIframe,
    handleMargins,
    handleDarkModeSettings,
    useDarkMode,
    isForcedColorMode,
  } from "../../scripts/loadExternalData";
  import { initTracking } from "../../scripts/tracker";
  import { transformSvgToDarkMode } from "../../scripts/transformSvgToDarkMode.js";

  export const events = initTracking();

  export const state = {
    title: "",
    introduction: "",
    source: "",
    subtext: "",
    images: [],
    imageWidth: "",
    darkMode: false,
    adaptedForDarkMode: false,
    darkModeSettings: "no_settings",
    expandable: false,
    isExpanded: false,
    expandableHeight: 0,
    imageAltText:""
  };
  let expHeight = 'auto';
  export let graphicTitle = "";
  export let hasSentInView = false;

  $: myRenderDarkMode = false;
  $: myRenderForcedColorMode = true;

  onMount(() => {
    window.addEventListener("resize", () => postRatio());

    if (!inIframe()) {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      document.getElementsByTagName("body")[0].style.margin = "0";
    } else {
      if (window.innerWidth <= 620) {
        document.getElementsByTagName("body")[0].style.margin = "0";
      }
    }

    setupLiveData();
    setupInviewEvent();
    fetchGraphicData();
  });

  function postRatio() {
    const containerElement = document.getElementsByTagName("body")[0];

    window.parent.postMessage(
      {
        ratio: containerElement.offsetHeight / window.innerWidth,
        location: window.location.href,
      },
      "*"
    );
  }

  function setupInviewEvent() {
    window.addEventListener("message", (ev) => {
      if (hasSentInView) return;

      if (typeof ev.data === "string" && ev.data.includes("INSIDE_VIEW")) {
        events.enterIntoView(
          "Visible",
          "Singelgrafik",
          state.title || graphicTitle || ""
        );
        hasSentInView = true;
      } else if (ev.data.isScrolledIntoView) {
        events.enterIntoView(
          "Visible",
          "Singelgrafik",
          state.title || graphicTitle || ""
        );
        hasSentInView = true;
      }
    });
  }

  function setupLiveData() {
    window.addEventListener("message", (ev) => {
      if (!ev.data.key || ev.data.value === undefined) return;

      const { key, value } = ev.data;

      if (key === "images") {
        state[key] = value.map((image) => {
          return {
            url: image,
          };
        });

        if (!value.length) setTimeout(() => postRatio(), 50);
      } else if (key === "expandable") {
        state[key] = value;

        setTimeout(() => postRatio(), 50);
      } else {
        state[key] = value;
      }
    });
  }

  function fetchGraphicData() {
    fetch(`${baseUrl}/fields/${getUrlVars().id}`)
      .then((data) => data.json())
      .then(({ fields, title }) => {
        graphicTitle = title;

        for (let name in state) {
          if (!fields.find(({ key }) => key === name)) continue;

          state[name] = fields.find(({ key }) => key === name).value;
        }

        handleDarkModeSettings(
          state.adaptedForDarkMode,
          state.darkMode,
          state.darkModeSettings
        );

        myRenderDarkMode = useDarkMode();
        myRenderForcedColorMode = isForcedColorMode();

        if (myRenderDarkMode && !myRenderForcedColorMode ) {
          document
            .getElementsByTagName("body")[0]
            .classList.add("body__dark-mode");

        } else if( myRenderForcedColorMode ) {


        } else {
          document
            .getElementsByTagName("body")[0]
            .classList.add("body__light-mode");
        }

        setTimeout(() => {setSize(!state.expandable); burstRatio(); }, 500);
      });
  }

  const burstRatio = () => {
    setTimeout(() => postRatio(), 50);
    setTimeout(() => postRatio(), 100);
    setTimeout(() => postRatio(), 200);
    setTimeout(() => postRatio(), 300);
    setTimeout(() => postRatio(), 400);
    setTimeout(() => postRatio(), 500);
    setTimeout(() => postRatio(), 1000);
  };

  $: state.images && burstRatio();


function setSize(exp) {

  if(!exp){
  let h = document.getElementsByTagName("BODY")[0].offsetHeight;
  let hPix = (h * (state.expandableHeight / 100)).toFixed(0);
  expHeight = hPix +'px';
  } else {
  expHeight = 'auto';
  }
  
}

</script>

<main
  class={`main__content-wrapper ${
    handleMargins() ? "main__padded-width" : "main__normal-width"
  } ${myRenderDarkMode ? "main__dark-mode" : "main__light-mode"} ${
    myRenderForcedColorMode ? "main__padded-top-bottom" : ""
  } ${handleMargins() && !getUrlVars().fullWidth ? "main__full-width" : ""}`}
>
  {#if state.title}
    <div
      style={state.imageWidth
        ? `max-width: ${state.imageWidth}px;`
        : "max-width: 560px;"}
      class="standard-title"
    >
      {@html state.title}
    </div>
  {/if}
  {#if state.introduction}
    <div
      style={state.imageWidth
        ? `max-width: ${state.imageWidth}px;`
        : "max-width: 560px;"}
      class="standard-ingress"
    >
      {@html state.introduction}
    </div>
  {/if}


  <div class="expander-wrapper" style={`height:${expHeight}; overflow:${state.expandable ? "hidden" :"unset"}`}>  
    {#if state.images.length}
      {#if state.images[state.images.length - 1].url.includes(".svg")}
        <InlineSVG
          src={state.images[state.images.length - 1].url}
          transformSrc={(svg) => transformSvgToDarkMode(svg, myRenderDarkMode, state?.imageAltText ?? "")}
          alt={state.title}
          class="standard-image"
          style={"max-width: 560px;"}
        />
      {:else}
        <img
          class="standard-image"
          style={state.imageWidth
            ? `max-width: ${state.imageWidth}px;`
            : "max-width: 560px;"}
          src={state.images[state.images.length - 1].url}
          alt={state.images[state.images.length - 1].altText || state.title}
        />
      {/if}
    {/if}

    {#if state.subtext}
      <div class="standard-subtext standard-ingress">
        {@html state.subtext}
      </div>
    {/if}

    {#if state.source}
      <div class="standard-source">
        {@html state.source}
      </div>
    {/if}
  </div>



  {#if state.expandable}
    <div class={`button-wrapper ${state.isExpanded ? "is__expanded" : ""}`}>
      <button
        on:click={() => {

         

          state.isExpanded = !state.isExpanded;

          setSize(state.isExpanded);

          

          burstRatio();

        }}
        class="select-button"
        >{state.isExpanded ? "Visa mindre" : "Visa mer"}<svg class="expicon"
          ><use
            xlink:href={`${state.isExpanded ? "#closesvg" : "#opensvg"}`}
          /></svg
        ></button
      >
    </div>
  {/if}
</main>

<style>
  .button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: absolute;
    width: 100%;
    bottom: -10px;
    padding: 30px 0 10px;
    background: linear-gradient(
      0,
      rgb(255, 255, 255) 70%,
      rgba(255, 255, 255, 0) 100%
    );
    margin-bottom: 10px;
    box-sizing: border-box;
    left: 0;
  }

  .main__full-width .button-wrapper {
    padding: 30px 16px 10px;
  }

  .main__dark-mode .button-wrapper {
    background: linear-gradient(
      0,
      rgb(20, 20, 20) 70%,
      rgba(22, 20, 20, 0) 100%
    );
  }

  .main__dark-mode .select-button {
    background-color: #333;
    color: white;
  }


  .expander-wrapper {
    position: relative;
    width: 100%;
  }

  .select-button {
    cursor: pointer;
    font-family:
      DNSans,
      Segoe UI,
      Trebuchet MS,
      Dejavu Sans,
      Helvetica Neue,
      Helvetica,
      Arial,
      sans-serif;
    width: 95%;
    font-size: 14px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #222;
    color: #222;
    display: inline-block;
    padding: 0;
    padding-top: 11px;
    padding-bottom: 11px;
    transition: background-color 0.15s ease-out;
    outline: 0;
    box-sizing: border-box;
    font-weight: 600;
    line-height: 1;
  }

  .select-button:hover {
    cursor: pointer;
    color: #fff;
    background-color: #333;
  }

  .button-wrapper.is__expanded {
    position: relative;
    padding-top: 0;
    padding-bottom: 30px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .expicon {
    position: relative;
    width: 17px;
    height: 17px;
    display: inline-block;
    vertical-align: text-bottom;
    fill: #666;
    margin-left: 8px;
  }

  .select-button:hover .expicon {
    fill: #666;
  }

  .standard-image {
    width: 100%;
    margin: 0 0 5px;
    display: block;
  }

  .main__content-wrapper {
    max-width: 680px;
    margin: 0px;
    position: relative;
  }

  @media screen and (max-width: 640px) {
    .main__full-width .select-button {
      margin: 0 0 0 -8px;
    }
  }

  @media screen and (min-width: 640px) {
    .main__full-width {
      margin: 0 auto;
    }
  }
</style>
